import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appProductStep]',
})
/**
 * Directive to mark a template as a product step
 * and inject it into the product stepper component.
 */
export class ProductStepDirective {
  /**
   * Constructor
   */
  constructor(public templateRef: TemplateRef<unknown>) {}
}
